'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var center = exports.center = {
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'center'
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/style/index.js
 ** module id = 281
 ** module chunks = 0
 **/